import React from "react";

const Body = ({ renderField, renderCheckbox, renderSelect, ...props }) => {
    const { number, type, carId, driverId, data, hasNoLimitManagement } = props;
    return (
        <>
            {renderField(number)}
            {renderSelect(type)}
            {renderCheckbox(hasNoLimitManagement)}
            {renderSelect({ ...carId, disabled: !!data.driverId })}
            {renderSelect({ ...driverId, disabled: !!data.carId })}
        </>
    );
};

export default Body;
